import { useContext } from "react";

import { ClubSettingsContext } from "./ClubSettingsContext";

export function useClubSettings() {
  const settings = useContext(ClubSettingsContext);
  if (!settings) {
    throw new Error("useClubSettings used outside of context");
  }
  return settings;
}
